export default __webpack_public_path__ + "static/media/banner5.3e6bfa4d.jpg";